/* Lumière Beauté — global.js */
(function () {
  'use strict';

  /* ---------------------------------------------- Mobile navigation */
  document.addEventListener('click', function (event) {
    const toggle = event.target.closest('[data-menu-toggle]');
    if (!toggle) return;
    const nav = document.getElementById('MobileNav');
    if (!nav) return;
    const open = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------------------------------------------- Quantity selector */
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-qty-change]');
    if (!button) return;
    const wrapper = button.closest('.product-form__qty');
    const input = wrapper && wrapper.querySelector('input[name="quantity"]');
    if (!input) return;
    const step = parseInt(button.getAttribute('data-qty-change'), 10);
    const min = parseInt(input.getAttribute('min') || '1', 10);
    const next = Math.max(min, (parseInt(input.value, 10) || min) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------------------------------------- Product media gallery */
  document.addEventListener('click', function (event) {
    const thumb = event.target.closest('[data-media-thumb]');
    if (!thumb) return;
    const gallery = thumb.closest('[data-product-gallery]');
    const main = gallery && gallery.querySelector('[data-media-main]');
    const src = thumb.getAttribute('data-media-src');
    if (main && src) {
      main.setAttribute('src', src);
      main.removeAttribute('srcset');
    }
  });

  /* ---------------------------------------------- Variant picker */
  class VariantPicker {
    constructor(root) {
      this.root = root;
      this.productData = JSON.parse(root.querySelector('[data-variant-json]').textContent);
      this.form = root.querySelector('form[action*="/cart/add"]');
      this.idInput = this.form && this.form.querySelector('input[name="id"]');
      root.addEventListener('change', () => this.onChange());
    }

    get selectedOptions() {
      return Array.from(this.root.querySelectorAll('select[data-option-index]')).map((s) => s.value);
    }

    onChange() {
      const selected = this.selectedOptions;
      const variant = this.productData.variants.find((v) =>
        v.options.every((option, index) => option === selected[index])
      );
      const priceEl = this.root.querySelector('[data-variant-price]');
      const button = this.form && this.form.querySelector('[data-add-button]');

      if (!variant) {
        if (button) {
          button.setAttribute('disabled', 'disabled');
          button.textContent = button.getAttribute('data-unavailable-text') || 'Unavailable';
        }
        return;
      }

      if (this.idInput) this.idInput.value = variant.id;
      if (priceEl && variant.price_formatted) priceEl.innerHTML = variant.price_formatted;

      if (button) {
        if (variant.available) {
          button.removeAttribute('disabled');
          button.textContent = button.getAttribute('data-add-text') || 'Add to cart';
        } else {
          button.setAttribute('disabled', 'disabled');
          button.textContent = button.getAttribute('data-sold-out-text') || 'Sold out';
        }
      }

      if (window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
  }

  /* ---------------------------------------------- Cart line quantity auto submit */
  document.addEventListener('change', function (event) {
    const input = event.target.closest('[data-cart-quantity]');
    if (!input) return;
    const form = input.closest('form');
    if (form) form.submit();
  });

  function init() {
    document.querySelectorAll('[data-variant-picker]').forEach((el) => new VariantPicker(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
